import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import { LanguageService } from 'src/app/@shared/services/language/language.service';

@Pipe({
    name: 'localizedDate',
    pure: false,
    standalone: false
})
export class LocalizedDatePipe implements PipeTransform {
  private datePipe: DatePipe;

  constructor(private readonly languageService: LanguageService) {}

  transform(value: Date | string | number, format?: string, timezone?: string): string | null {
    const locale = this.languageService.getSelectedLanguage()?.symbol ?? 'he';
    this.datePipe = new DatePipe(locale);
    return this.datePipe.transform(value, format, timezone);
  }
}
